import { render, staticRenderFns } from "./SelectTemplate.vue?vue&type=template&id=2127b8da&scoped=true"
import script from "./SelectTemplate.vue?vue&type=script&lang=js"
export * from "./SelectTemplate.vue?vue&type=script&lang=js"
import style0 from "./SelectTemplate.vue?vue&type=style&index=0&id=2127b8da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2127b8da",
  null
  
)

export default component.exports